import { FormManager } from '@bark/bark-core/src/components/legacy-scripts/form-manager';
import { _t } from '@bark/bark-core';

/**
 * Handle form errors returned from the API
 * @param {array} errors An array of objects, with each object in the form<pre>
 *  {
 *      fieldname: string,
 *      msg: string
 *  }
 */
function handleFormErrors(errors) {
	var i;

	for (i = 0; i < errors.length; i++) {
		if (errors[i].fieldname === 'general') {
			Bark.alertModal(
				errors[i].msg,
				_t('seller_settings_account-details:modal.close-button'),
			);
		} else {
			Bark.showFormErrorsBootstrap(errors[i].fieldname, errors[i].msg);
		}
	}
}

/**
 * Show the error modal
 * @param {string} msg [optional] The error message to show
 * @param {boolean} keepModalsOpen [optional] True to keep the current modal open
 */
function errorModal(msg, keepModalsOpen) {
	if (!keepModalsOpen) {
		$('.modal').modal('hide');
	}

	Bark.alertModal(msg || _t('seller_settings_account-details:errors.generic-error'));
	Bark.hideLoading();
}

/**
 * Validate an email address locally
 * @param {string} emailAddress The email address to validate
 * @returns {boolean}
 */
function validateUpdateEmail(emailAddress) {
	if (!emailAddress) {
		Bark.showFormErrorsBootstrap(
			'user_email_address',
			_t('seller_settings_account-details:errors.email.no-email'),
		);
		return false;
	}

	if (!emailAddress.match(/.*\@.*\./)) {
		Bark.showFormErrorsBootstrap(
			'user_email_address',
			_t('seller_settings_account-details:errors.email.invalid-email'),
		);
		return false;
	}

	return true;
}

/**
 * Validate the updated password
 * @param {string} currentPassword The old password
 * @param {string} newPassword The proposed new password
 * @param {string} confirmPassword Confirmation of the new password
 * @param loginMethod
 * @returns {boolean} <b>True</b> if the password passed local validation
 */
function validateUpdatePassword(
	currentPassword = '',
	newPassword = '',
	confirmPassword = '',
	loginMethod = 'password',
) {
	const isLoginMethodPassword = loginMethod === 'password';

	if (isLoginMethodPassword && !currentPassword) {
		Bark.showFormErrorsBootstrap(
			'account_current_password',
			_t('seller_settings_account-details:errors.password.no-current'),
		);
		return false;
	}

	if (!newPassword) {
		Bark.showFormErrorsBootstrap(
			'account_new_password',
			_t('seller_settings_account-details:errors.password.no-new'),
		);
		return false;
	}

	if (newPassword.length < 6) {
		Bark.showFormErrorsBootstrap(
			'account_new_password',
			_t('seller_settings_account-details:errors.password.too-short'),
		);
		return false;
	}

	if (isLoginMethodPassword && currentPassword === newPassword) {
		Bark.showFormErrorsBootstrap(
			'account_new_password',
			_t('seller_settings_account-details:errors.password.same-as-existing'),
		);
		return false;
	}

	if (confirmPassword !== newPassword) {
		Bark.showFormErrorsBootstrap(
			'account_new_password_confirm',
			_t('seller_settings_account-details:errors.password.no-match'),
		);
		return false;
	}

	return true;
}

function clearPasswordForm() {
	if ($('#account_current_password').length) {
		$('#account_current_password').val('');
	}
	$('#account_new_password').val('');
	$('#account_new_password_confirm').val('');
}

function bindListeners() {
	$('#user_preferred_contact_number')
		.off('keyup.format')
		.on('keyup.format', function (e) {
			if (window.Bark.in_array(e.keyCode, [8, 37, 39])) {
				return false;
			}
			this.value = this.value.replace(/[^\d#()\[\]\-+ ]/, '');
		});

	$('#user_mobile_notification_number')
		.off('keyup.format')
		.on('keyup.format', function (e) {
			if (window.Bark.in_array(e.keyCode, [8, 37, 39])) {
				return false;
			}
			this.value = this.value.replace(/[^\d#()\[\]\-+ ]/, '');
		});
	// Trigger by default
	$('#user_mobile_notification_number').trigger('keyup.format');
	$('#user_preferred_contact_number').trigger('keyup.format');
}

export default function AccountDetailsSettings() {
	try {
		const _formManager = FormManager();

		/**
		 * Window.Bark global
		 * @type {Window.Bark}
		 */
		var Bark = (window.Bark = window.Bark || {});

		/**
		 * Window.Bark.accountDetails global
		 * @type {Window.Bark.accountDetails}
		 */
		const accountDetails = (Bark.accountDetails = Bark.accountDetails || {});

		/**
		 * An object of required data
		 * @type {Window.Bark.accountDetails.data}
		 */
		var data = (accountDetails.data = accountDetails.data || {});

		/**
		 * Templates
		 * @type {Window.Bark.accountDetails.templates}
		 */
		var templates = (accountDetails.templates = accountDetails.templates || {});

		/**
		 * AJAX to update an email address
		 * @param {boolean} withDeferred <b>True</b> to use deferring
		 */
		accountDetails.updateEmailAddress = function (deferred) {
			const $selector = $('#user_email_address');

			var payload = {
				email: $selector.val(),
			};

			if (payload.email === $selector.attr('data-original-email')) {
				// Nothing to update
				deferred.resolve();
				return true;
			}

			if (!validateUpdateEmail(payload.email)) {
				deferred.reject($('label[for="user_email_address"]'));
				return false;
			}

			Bark.showLoading();

			Bark.api(
				'user/email',
				payload,
				function (e) {
					Bark.hideLoading();

					if (e.errors) {
						handleFormErrors(e.errors);
						deferred.reject($('label[for="user_email_address"]'));
						return;
					}

					if (e.status) {
						Bark.json({ url: '/json/reset-seller-session/' }).fail(function () {
							Bark.jsr.logError(
								'reset-seller-session',
								'Email updated ok. Failed to set session',
							);
							console.error(
								'Email address was updated okay, but there was an error updating your session.',
							);
						});

						$selector.attr('data-original-email', payload.email);

						deferred.resolve();
						_formManager.dirty('accountDetails-contact-details', false);
						return;
					}

					deferred.reject($('label[for="user_email_address"]'));

					errorModal(_t('seller_settings_account-details:errors.email.default'));
				},
				function (err) {
					Bark.hideLoading();
					deferred.reject($('label[for="user_email_address"]'));
					errorModal(_t('seller_settings_account-details:errors.email.default'));
				},
				'POST',
			);

			return true;
		};

		/**
		 * Update SMS notification number
		 */
		accountDetails.updateMobileNotificationNumber = function (deferred) {
			const $selector = $('#user_mobile_notification_number');

			const payload = {
				mobileNotificationNumber: $selector.val(),
			};

			if (
				payload.mobileNotificationNumber === $selector.attr('data-original-mobile-number')
			) {
				// Nothing to update
				deferred.resolve();
				return true;
			}

			Bark.showLoading();

			Bark.api(
				'seller/mobile-notification-number',
				payload,
				function (changeNumberResponse) {
					Bark.hideLoading();

					if (changeNumberResponse.errors) {
						handleFormErrors(changeNumberResponse.errors);
						$selector.val($selector.attr('data-original-mobile-number'));
						deferred.reject($('label[for="user_mobile_notification_number"]'));
						return;
					}

					if (changeNumberResponse.status) {
						$selector.attr(
							'data-original-mobile-number',
							payload.mobileNotificationNumber,
						);
						if (changeNumberResponse.successMessage) {
							Bark.alertModal(
								changeNumberResponse.successMessage,
								_t('seller_settings_account-details:modal.close-button'),
							);
						}
						deferred.resolve();
						_formManager.dirty('accountDetails-contact-details', false);
						return;
					}

					deferred.reject($('label[for="user_mobile_notification_number"]'));

					errorModal(_t('seller_settings_account-details:errors.sms-notification'));
				},
				function (err) {
					Bark.hideLoading();
					deferred.reject($('label[for="user_mobile_notification_number"]'));
					errorModal(_t('seller_settings_account-details:errors.sms-notification'));
				},
				'POST',
			);

			return true;
		};

		accountDetails.updatePreferredContactNumber = function (deferred) {
			const $selector = $('#user_preferred_contact_number');
			const payload = {
				preferredContactNumber: $selector.val(),
			};

			if (
				payload.preferredContactNumber ===
				$selector.attr('data-original-preferred-contact-number')
			) {
				// Nothing to update
				deferred.resolve();
				return true;
			}

			Bark.showLoading();

			Bark.api(
				'seller/preferred-contact-number',
				payload,
				function (changeNumberResponse) {
					Bark.hideLoading();

					if (changeNumberResponse.errors) {
						handleFormErrors(changeNumberResponse.errors);
						$selector.val($selector.attr('data-original-preferred-contact-number'));
						deferred.reject($('label[for="user_preferred_contact_number"]'));
						return;
					}

					if (changeNumberResponse.status) {
						$selector.attr(
							'data-original-preferred-contact-number',
							payload.preferredContactNumber,
						);
						if (changeNumberResponse.successMessage) {
							Bark.alertModal(
								changeNumberResponse.successMessage,
								_t('seller_settings_account-details:modal.close-button'),
							);
						}
						deferred.resolve();
						_formManager.dirty('accountDetails-contact-details', false);
						return;
					}

					deferred.reject($('label[for="user_preferred_contact_number"]'));

					errorModal(_t('seller_settings_account-details:errors.preferred-contact'));
				},
				function (err) {
					Bark.hideLoading();
					deferred.reject($('label[for="user_preferred_contact_number"]'));
					errorModal(_t('seller_settings_account-details:errors.preferred-contact'));
				},
				'POST',
			);

			return true;
		};

		accountDetails.updatePassword = () => {
			const loginMethod = $('#login_method_for_change_password').val();
			let payload = {
				newpass: $('#account_new_password').val(),
				currentpass: null,
			};

			if (loginMethod === 'password') {
				payload.currentpass = $('#account_current_password').val();
			}

			if (
				!validateUpdatePassword(
					payload.currentpass,
					payload.newpass,
					$('#account_new_password_confirm').val(),
					loginMethod,
				)
			) {
				return;
			}

			Bark.showLoading();

			Bark.api(
				'user/password-web',
				payload,
				function (e) {
					if (e.status) {
						$('#change-password-modal').modal('hide');

						// As the password is in the network logs in plain text, reload the page.
						document.location.reload();
						return;
					}

					Bark.hideLoading();

					if (e.errors) {
						handleFormErrors(e.errors);
						return;
					}

					Bark.alertModal(
						e.message || _t('seller_settings_account-details:errors.password.default'),
					);
				},
				function () {
					errorModal();
					// @todo error handling
				},
				'POST',
			);
		};

		$(function () {
			$('.js-update-password')
				.off('click.update')
				.on('click.update', accountDetails.updatePassword);

			$('.js-close-change-password-modal')
				.off('click.close')
				.on('click.close', function () {
					clearPasswordForm();
				});

			$('.close-modal-cross').click(function () {
				clearPasswordForm();
			});

			_formManager.register(
				'accountDetails-contact-details',
				function (deferred) {
					accountDetails.updateEmailAddress(deferred);
					accountDetails.updateMobileNotificationNumber(deferred);
					accountDetails.updatePreferredContactNumber(deferred);
				},
				function () {
					// Reset fields to original values when user cancels.
					$('#user_email_address').val(
						$('#user_email_address').attr('data-original-email'),
					);
					$('#user_mobile_notification_number').val(
						$('#user_mobile_notification_number').attr('data-original-mobile-number'),
					);
					$('#user_preferred_contact_number').val(
						$('#user_preferred_contact_number').attr(
							'data-original-preferred-contact-number',
						),
					);
					_formManager.dirty('accountDetails-contact-details', false);
				},
			);

			// Dirty the form when things ch-ch-ch-ch-chaaaange
			$('#user_email_address')
				.off('change.update, keyup')
				.on('change.update, keyup', function () {
					_formManager.dirty('accountDetails-contact-details', true);
				});
			$('#user_mobile_notification_number')
				.off('change.update, keyup')
				.on('change.update, keyup', function () {
					_formManager.dirty('accountDetails-contact-details', true);
				});
			$('#user_preferred_contact_number')
				.off('change.update, keyup')
				.on('change.update, keyup', function () {
					_formManager.dirty('accountDetails-contact-details', true);
				});
			bindListeners();
			$('#account_details').removeClass('waiting');
		});
	} catch (e) {
		console.log(e);
	}
}
